import { Footer, FooterBar, FooterBarLink, FooterLink, FooterLinkGroup, FooterLinks } from '@volvo/vcdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ChangeLanguageModal from '@/components/modals/ChangeLanguageModal';
import { cookiePolicyLink, dealerLocatorLink, privacyPolicyLink } from '@/utils/baseLinks';

const PublicFooter: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <>
      <Footer>
        <FooterLinks>
          <FooterLinkGroup title={t(($) => $.components.footer.useful)}>
            <FooterLink href="https://www.volvopenta.com/your-engine/manuals-and-handbooks/">
              {t(($) => $.components.footer.manuals_and_handbooks)}
            </FooterLink>
            <FooterLink href={dealerLocatorLink}>{t(($) => $.components.footer.dealer_locator)}</FooterLink>
            <FooterLink href="https://www.volvopenta.com/industrial/services-and-solutions/protection-plans/warranty/">
              {t(($) => $.components.footer.warranty)}
            </FooterLink>
          </FooterLinkGroup>

          <FooterLinkGroup title={t(($) => $.components.footer.parts_column)}>
            <FooterLink href="https://www.volvopenta.com/industrial/industrial-engine-parts/">
              {t(($) => $.components.footer.parts)}
            </FooterLink>
            <FooterLink href="https://www.volvopenta.com/industrial/industrial-engine-parts/remanufacturing/">
              {t(($) => $.components.footer.remanufactured)}
            </FooterLink>
          </FooterLinkGroup>

          <FooterLinkGroup title={t(($) => $.components.footer.contact)}>
            <FooterLink href="https://www.volvopenta.com/your-engine/volvo-penta-action-service/">
              {t(($) => $.components.footer.action_service)}
            </FooterLink>
            <FooterLink href={`https://www.volvopenta.com/connect/faq`}>{t(($) => $.components.footer.faq)}</FooterLink>
            <FooterLink href="https://www.volvopenta.com/about-us/contact-us/">
              {t(($) => $.components.footer.contact_us)}
            </FooterLink>
          </FooterLinkGroup>

          <FooterLinkGroup title="Social Media">
            <FooterLink iconStart="facebook" iconEnd="link-new-window" href="https://www.facebook.com/VolvoPenta/">
              Facebook
            </FooterLink>
            <FooterLink iconStart="youtube" iconEnd="link-new-window" href="https://www.youtube.com/user/ABVolvoPenta">
              YouTube
            </FooterLink>
            <FooterLink iconStart="instagram" href="https://www.instagram.com/volvopenta/" iconEnd="link-new-window">
              Instagram
            </FooterLink>
            <FooterLink iconStart="linkedin" href="https://www.linkedin.com/company/2089" iconEnd="link-new-window">
              LinkedIn
            </FooterLink>
          </FooterLinkGroup>
        </FooterLinks>
        <FooterBar copyright={`© Copyright AB Volvo ${year}`} logotype="volvo-penta-spread-word-mark-stacked">
          <FooterBarLink href="https://www.volvogroup.com/" target="_blank">
            www.volvogroup.com
          </FooterBarLink>
          <ChangeLanguageModal />
          <FooterBarLink href={privacyPolicyLink} target="_blank">
            {t(($) => $.components.footer.privacy_policy)}
          </FooterBarLink>
          <FooterBarLink href={cookiePolicyLink} target="_blank">
            {t(($) => $.components.footer.cookie_policy)}
          </FooterBarLink>
        </FooterBar>
      </Footer>
    </>
  );
};

export default PublicFooter;
